// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"SLpx3X7iuIyNnCAh3HxTV"};